import React from 'react';
import {
  BarChart3, BookUser, Boxes, Calculator, CalendarRange, FileText, Home, Landmark, LineChart, MessageSquare, Package, Percent,
  Receipt, Settings, ShieldCheck, ShoppingCart, Smartphone, Tags, TrendingUp, Truck, Wallet, Warehouse,
} from 'lucide-react';

// Sections of the admin panel, shared by the side menu and the "Móviles/Tablet" button page.
export interface AdminMenuItem { path: string; label: string; Icon: React.ComponentType<{ className?: string }>; group: string; exact?: boolean; }

const ALL_ITEMS: Array<AdminMenuItem & { superadminOnly?: boolean }> = [
  { path: '/admin', Icon: Home, label: 'Inicio', exact: true, group: '' },
  { path: '/admin/moviles', Icon: Smartphone, label: 'Móviles/Tablet', group: '' },
  { path: '/admin/pedidos-mensuales', Icon: CalendarRange, label: 'Pedidos mensuales', group: 'Día a día' },
  { path: '/admin/remitos', Icon: Receipt, label: 'Remitos', group: 'Día a día' },
  { path: '/admin/stock-propio', Icon: Warehouse, label: 'Stock proveedores', group: 'Día a día' },
  { path: '/admin/stock-clientes', Icon: Boxes, label: 'Stock clientes', group: 'Día a día' },
  { path: '/admin/clientes', Icon: BookUser, label: 'Clientes', group: 'Clientes y proveedores' },
  { path: '/admin/proveedores', Icon: Truck, label: 'Proveedores', group: 'Clientes y proveedores' },
  { path: '/admin/cuentas-corrientes', Icon: Wallet, label: 'Cuentas corrientes', group: 'Clientes y proveedores' },
  { path: '/admin/cheques', Icon: Landmark, label: 'Cheques', group: 'Clientes y proveedores' },
  { path: '/admin/cotizador', Icon: Calculator, label: 'Cotizador', group: 'Precios' },
  { path: '/admin/analisis-mercado', Icon: TrendingUp, label: 'Análisis de mercado', group: 'Precios' },
  { path: '/admin/etiquetas', Icon: Tags, label: 'Etiquetas', group: 'Precios' },
  { path: '/admin/estadisticas-negocio', Icon: LineChart, label: 'Estadísticas de negocio', group: 'Números' },
  { path: '/admin/informes/stock', Icon: FileText, label: 'Informe de stock', group: 'Números' },
  { path: '/admin/informes/aumentos', Icon: Percent, label: 'Aumentos de precios', group: 'Números' },
  { path: '/admin/productos', Icon: Package, label: 'Productos', group: 'Tienda web' },
  { path: '/admin/pedidos', Icon: ShoppingCart, label: 'Pedidos web', group: 'Tienda web' },
  { path: '/admin/mensajes', Icon: MessageSquare, label: 'Mensajes', group: 'Tienda web' },
  { path: '/admin/estadisticas', Icon: BarChart3, label: 'Estadísticas web', group: 'Tienda web' },
  { path: '/admin/configuracion', Icon: Settings, label: 'Configuración', group: 'Sistema' },
  { path: '/admin/seguridad', Icon: ShieldCheck, label: 'Seguridad', group: 'Sistema', superadminOnly: true },
];

// An admin limited to some clients only sees the sections related to them.
const RESTRICTED_MENU_PATHS = new Set(['/admin/moviles', '/admin/etiquetas', '/admin/cuentas-corrientes', '/admin/cheques', '/admin/clientes', '/admin/proveedores', '/admin/estadisticas-negocio', '/admin/remitos', '/admin/pedidos-mensuales', '/admin/stock-propio']);

export const adminMenuItems = (user: { role?: string; allowedClientIds?: unknown } | null | undefined): AdminMenuItem[] => {
  const restricted = Array.isArray(user?.allowedClientIds);
  return ALL_ITEMS.filter((item) => (!item.superadminOnly || user?.role === 'superadmin') && (!restricted || RESTRICTED_MENU_PATHS.has(item.path)));
};

export const groupMenuItems = <T extends { group: string }>(items: T[]) => items.reduce<Array<{ title: string; items: T[] }>>((groups, item) => {
  const last = groups[groups.length - 1];
  if (last && last.title === item.group) last.items.push(item); else groups.push({ title: item.group, items: [item] });
  return groups;
}, []);
